import { Habit } from '@griply/types';
import { buildPriorityHabitSections, getWeekStartsOn } from '@griply/utils';
import { useHabits } from 'features/tasks';
import { useMemo } from 'react';
import { useToday } from 'shared/contexts/today';
import { useUser } from 'shared/hooks/use-user';

export const usePriorityHabitSections = () => {
  const today = useToday();
  const user = useUser();

  const habits = useHabits({
    uncompletedOnly: true,
    unArchivedOnly: true,
  });

  const sections = useMemo(
    () =>
      buildPriorityHabitSections({
        habits,
        habitSortingMode: user?.settings?.habitSortingMode,
        habitGroupSorting: user?.settings?.habitGroupSorting?.priority?.sorting,
        today,
        weekStartsOn: getWeekStartsOn(user),
      }).map((group) => ({
        id: group.priority,
        items: group.tasks as Habit[],
      })),
    [habits, user, today],
  );

  return {
    sections,
    habits,
  };
};
